import { Injectable } from '@angular/core';
import { AssetBasketService } from '@thehubz/client/asset-services';
import { AppSettings, AssetUIModel, SelectionAsset } from '@thehubz/client/core';
import { UserAgencyModel } from '@thehubz/client/data-access-api';
import { AnyType } from '@thehubz/shared/model';

@Injectable()
export class CollectionSelectionService {
  constructor(private assetBasketService: AssetBasketService) {}

  getSelectedItemsData(type: string, dataType: string): SelectionAsset[] {
    if (sessionStorage.getItem(AppSettings.SESSION_STORAGE_KEY)) {
      const selectedItems = JSON.parse(sessionStorage[AppSettings.SESSION_STORAGE_KEY]);
      const currentTypeIndex = selectedItems.findIndex((obj: { type: string }) => obj.type === type);
      return selectedItems[currentTypeIndex][dataType] ?? [];
    }
    return [];
  }

  setSelectedItems(type: string, assets: SelectionAsset[], checked: boolean) {
    if (sessionStorage.getItem(AppSettings.SESSION_STORAGE_KEY)) {
      const selectedItems = JSON.parse(sessionStorage[AppSettings.SESSION_STORAGE_KEY]);
      const currentTypeIndex = selectedItems.findIndex((obj: { type: string }) => obj.type === type);
      selectedItems[currentTypeIndex].items = assets;
      if (checked) {
        selectedItems[currentTypeIndex].selectedAll = true;
      } else {
        selectedItems[currentTypeIndex].selectedAll = false;
      }
      sessionStorage.setItem(AppSettings.SESSION_STORAGE_KEY, JSON.stringify(selectedItems));
    }
  }

  unSelectAll(type: string, checked: boolean) {
    const selectedItems = JSON.parse(sessionStorage[AppSettings.SESSION_STORAGE_KEY]);
    const currentTypeIndex = selectedItems.findIndex((obj: { type: string }) => obj.type === type);
    if (currentTypeIndex !== -1) {
      selectedItems[currentTypeIndex].items = [];
      if (checked) {
        selectedItems[currentTypeIndex].selectedAll = true;
      } else {
        selectedItems[currentTypeIndex].selectedAll = false;
      }
    }
    sessionStorage.setItem(AppSettings.SESSION_STORAGE_KEY, JSON.stringify(selectedItems));
  }

  updateSelectedItems(type: string, assets: SelectionAsset[], checked: boolean) {
    if (sessionStorage.getItem(AppSettings.SESSION_STORAGE_KEY)) {
      const selectedItems = JSON.parse(sessionStorage[AppSettings.SESSION_STORAGE_KEY]);
      const currentTypeIndex = selectedItems.findIndex((obj: { type: string }) => obj.type === type);
      if (currentTypeIndex !== -1) {
        assets.forEach((asset) => {
          const itemIndex = selectedItems[currentTypeIndex].items.findIndex((item: SelectionAsset) => item._id === asset._id);
          if (itemIndex === -1) {
            selectedItems[currentTypeIndex].items.push(asset);
          } else {
            const itemsFiltered = selectedItems[currentTypeIndex].items.filter((item: SelectionAsset) => {
              return item._id !== asset._id;
            });
            selectedItems[currentTypeIndex].items = itemsFiltered;
          }
        });
        if (checked) {
          selectedItems[currentTypeIndex].selectedAll = true;
        } else {
          selectedItems[currentTypeIndex].selectedAll = false;
        }
      }
      sessionStorage.setItem(AppSettings.SESSION_STORAGE_KEY, JSON.stringify(selectedItems));
    }
  }

  getPublishCollectionDto(data: UserAgencyModel[]): AnyType {
    return data.map((item) => {
      return {
        key: item._id,
        company: item._id,
        name: item.name,
        clients: item.clients.map((client: { name: string; _id: string; brands: Array<any> }) => {
          return {
            name: client.name,
            key: client._id,
            client: client._id,
            brands: client.brands.map((brand: { name: string; _id: string }) => {
              return { name: brand.name, key: brand._id, brand: brand._id };
            }),
          };
        }),
      };
    });
  }

  /**
   * updates the collection basket based on the selection event
   * @param event
   */
  updateCollectionBasket(event: { asset: AssetUIModel; checked: boolean }, clearBasket = false) {
    if (clearBasket) {
      this.assetBasketService.clearMyBasket();
      return;
    }
    if (!this.assetBasketService.isInBasket(event.asset._id)) {
      if (!event.checked) {
        this.assetBasketService.removeFromBasket(event.asset._id);
      } else {
        this.assetBasketService.addToBasket(event.asset._id);
      }
    } else {
      this.assetBasketService.removeFromBasket(event.asset._id);
    }
  }
}
